

import jsPDF from 'jspdf';
import {
  Button,
  Col,
  Row,
  Table,
  message,
  Select,
  Card,
} from 'antd';
import 'jspdf-autotable';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { bunldeUnVerifyListById, bunldeVerifyListById } from '../../slices/stock-verify';
const { Option } = Select;

export default function PrintStockVerification() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [verifyPage, setVerifyPage] = useState(1);
  const [unverifyPage, setUnverifyPage] = useState(1);
  const [verifyPageSize, setVerifyPageSize] = useState(10);
  const [unverifyPageSize, setUnverifyPageSize] = useState(10);

  const [verifyData, setVerifyData] = useState([]);
  const [unverifyData, setUnverifyData] = useState([]);
  const [verifyTotals, setVerifyTotals] = useState({
    total_weight: 0,
    total_pieces: 0,
    total_bundles: 0
  });
  const [unverifyTotals, setUnverifyTotals] = useState({
    total_weight: 0,
    total_pieces: 0,
    total_bundles: 0
  });
  const [loading, setLoading] = useState(false);

  const fetchBothData = async () => {
    setLoading(true);
    try {
      const unverifyRes = await dispatch(
        bunldeUnVerifyListById({
          report_id: id,
          page: 1,
          pagesize: 5000,
          ...(search && { search }),
          ...(orderBy && { ordering: orderBy }),
        })
      );

      if (bunldeUnVerifyListById.fulfilled.match(unverifyRes)) {
        setUnverifyData(unverifyRes.payload.results.data);
        if (unverifyRes.payload.results.totals) {
          setUnverifyTotals(unverifyRes.payload.results.totals);
        } else {
          calculateUnverifyTotals(unverifyRes.payload.results.data);
        }
      }

      const verifyRes = await dispatch(
        bunldeVerifyListById({
          report_id: id,
          page: 1,
          pagesize: 5000,
          ...(search && { search }),
          ...(orderBy && { ordering: orderBy }),
        })
      );

      if (bunldeVerifyListById.fulfilled.match(verifyRes)) {
        setVerifyData(verifyRes.payload.results.data);
        if (verifyRes.payload.results.totals) {
          setVerifyTotals(verifyRes.payload.results.totals);
        } else {
          calculateVerifyTotals(verifyRes.payload.results.data);
        }
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      message.error('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };
  const calculateUnverifyTotals = (data) => {
    const totals = data.reduce((acc, item) => {
      return {
        total_weight: acc.total_weight + (item.weight || 0),
        total_pieces: acc.total_pieces + (item.pieces || 0),
        total_bundles: acc.total_bundles + 1,
      };
    }, { total_weight: 0, total_pieces: 0, total_bundles: 0 });

    setUnverifyTotals(totals);
  };

  const calculateVerifyTotals = (data) => {
    const totals = data.reduce((acc, item) => {
      return {
        total_weight: acc.total_weight + (item.weight || 0),
        total_pieces: acc.total_pieces + (item.pieces || 0),
        total_bundles: acc.total_bundles + 1,
      };
    }, { total_weight: 0, total_pieces: 0, total_bundles: 0 });

    setVerifyTotals(totals);
  };

  useEffect(() => {
    fetchBothData();
  }, [id, unverifyPage, unverifyPageSize, verifyPage, verifyPageSize, search, orderBy]);

  const handlePrintBoth = () => {
    const doc = new jsPDF();
    const unverifiedTitle = 'Unverified Bundles';
    doc.text(unverifiedTitle, 14, 10);

    const unverifiedRows = (unverifyData || []).map((item, index) => [
      index + 1,
      item.bundle_no || 'N/A',
      'Unverified',
      item.die_profile || 'N/A',
      item.length || 'N/A',
      item.pieces || 'N/A',
      item.weight?.toFixed(3) || 'N/A',
      item.avg_weight?.toFixed(3) || 'N/A',
      item.alloy || 'N/A',
      item.party || 'N/A',
    ]);
    unverifiedRows.push([
      '',
      `Total (${unverifyTotals.total_bundles} bundles)`,
      '',
      '',
      '',
      unverifyTotals.total_pieces,
      unverifyTotals.total_weight?.toFixed(3),
      '',
      '',
      ''
    ]);

    doc.autoTable({
      head: [['#', 'Bundle No.', 'Status', 'Profile No', 'Length', 'Pieces', 'Weight', 'Avg. Weight', 'Alloy', 'Customer Name']],
      body: unverifiedRows,
      startY: 20,
      theme: 'grid',
      styles: { overflow: 'linebreak' },
      headStyles: { fillColor: [66, 139, 202] },
      footStyles: { fillColor: [220, 220, 220], textColor: [0, 0, 0], fontStyle: 'bold' },
    });
    doc.addPage();
    const verifiedTitle = 'Verified Bundles';
    doc.text(verifiedTitle, 14, 10);

    const verifiedRows = (verifyData || []).map((item, index) => [
      index + 1,
      item.bundle_no || 'N/A',
      'Verified',
      item.die_profile || 'N/A',
      item.length || 'N/A',
      item.pieces || 'N/A',
      item.weight?.toFixed(3) || 'N/A',
      item.avg_weight?.toFixed(3) || 'N/A',
      item.alloy || 'N/A',
      item.party || 'N/A',
    ]);
    verifiedRows.push([
      '',
      `Total (${verifyTotals.total_bundles} bundles)`,
      '',
      '',
      '',
      verifyTotals.total_pieces,
      verifyTotals.total_weight?.toFixed(3),
      '',
      '',
      ''
    ]);

    doc.autoTable({
      head: [['#', 'Bundle No.', 'Status', 'Profile No', 'Length', 'Pieces', 'Weight', 'Avg. Weight', 'Alloy', 'Customer Name']],
      body: verifiedRows,
      startY: 20,
      theme: 'grid',
      styles: { overflow: 'linebreak' },
      headStyles: { fillColor: [66, 139, 202] },
      footStyles: { fillColor: [220, 220, 220], textColor: [0, 0, 0], fontStyle: 'bold' },
    });

    doc.save(`Bundle_Verification_Report.pdf`);
  };

  const columns = [
    {
      title: 'Bundle No.',
      dataIndex: 'bundle_no',
      key: 'bundle_no',
      width: '8%',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (status ? 'Verified' : 'Unverified'),
    },
    {
      title: ' Profile No',
      dataIndex: 'die_profile',
      key: 'die_profile',
    },
    {
      title: 'Length',
      dataIndex: 'length',
      key: 'length',
    },
    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',
    },
    {
      title: 'Weight',
      dataIndex: 'weight',
      key: 'weight',
      render: (weight) => weight != null ? weight?.toFixed(3) : 'N/A',
    },
    {
      title: 'Avg. Weight',
      dataIndex: 'avg_weight',
      key: 'avg_weight',
      render: (avg_weight) => avg_weight != null ? avg_weight?.toFixed(3) : 'N/A',
    },
    {
      title: 'Alloy',
      dataIndex: 'alloy',
      key: 'alloy',
    },
    {
      title: 'Customer Name',
      dataIndex: 'party',
      key: 'party',
    },
  ];
  const unverifiedSummary = () => (
    <Table.Summary fixed>
      <Table.Summary.Row style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
        <Table.Summary.Cell index={0} colSpan={2}>Total ({unverifyTotals.total_bundles} bundles)</Table.Summary.Cell>
        <Table.Summary.Cell index={2}></Table.Summary.Cell>
        <Table.Summary.Cell index={3}></Table.Summary.Cell>
        <Table.Summary.Cell index={4}>{unverifyTotals.total_pieces}</Table.Summary.Cell>
        <Table.Summary.Cell index={5}>{unverifyTotals.total_weight?.toFixed(3)}</Table.Summary.Cell>
        <Table.Summary.Cell index={6}></Table.Summary.Cell>
        <Table.Summary.Cell index={7}></Table.Summary.Cell>
        <Table.Summary.Cell index={8}></Table.Summary.Cell>
      </Table.Summary.Row>
    </Table.Summary>
  );

  const verifiedSummary = () => (
    <Table.Summary fixed>
      <Table.Summary.Row style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
        <Table.Summary.Cell index={0} colSpan={2}>Total ({verifyTotals.total_bundles} bundles)</Table.Summary.Cell>
        <Table.Summary.Cell index={2}></Table.Summary.Cell>
        <Table.Summary.Cell index={3}></Table.Summary.Cell>
        <Table.Summary.Cell index={4}>{verifyTotals.total_pieces}</Table.Summary.Cell>
        <Table.Summary.Cell index={5}>{verifyTotals.total_weight?.toFixed(3)}</Table.Summary.Cell>
        <Table.Summary.Cell index={6}></Table.Summary.Cell>
        <Table.Summary.Cell index={7}></Table.Summary.Cell>
        <Table.Summary.Cell index={8}></Table.Summary.Cell>
      </Table.Summary.Row>
    </Table.Summary>
  );

  return (
    <div className="stock-verification-container" style={{ padding: '20px' }}>
      <Row justify="center" style={{ marginBottom: '20px' }}>
        <Col span={24}>
          <Card title="Bundle Verification Report" headStyle={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold' }}>
            <Row justify="end" style={{ marginBottom: '20px' }}>
              <Col>
                <Button type="primary" size="large" onClick={handlePrintBoth}>
                  Download Pdf
                </Button>
              </Col>
            </Row>

            <div className="unverified-table-section">
              <h2 style={{ textAlign: 'center', margin: '20px 0', fontWeight: 'bold' }}>Unverified Bundles</h2>
              <Table
                loading={loading}
                dataSource={unverifyData}
                rowKey={(record, index) => `unverified-${index}`}
                pagination={false}
                columns={columns}
                bordered
                summary={unverifiedSummary}
              />
            </div>

            <div className="verified-table-section" style={{ marginTop: '30px' }}>
              <h2 style={{ textAlign: 'center', margin: '20px 0', fontWeight: 'bold' }}>Verified Bundles</h2>
              <Table
                loading={loading}
                dataSource={verifyData}
                rowKey={(record, index) => `verified-${index}`}
                pagination={false}
                columns={columns}
                bordered
                summary={verifiedSummary}
              />
            </div>
          </Card>
        </Col>

      </Row>
    </div>
  );
}